var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/controllers/charts.controller.ts
import { Controller, Get, Query } from "@sker/core";
function _ts_decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate, "_ts_decorate");
function _ts_metadata(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata, "_ts_metadata");
function _ts_param(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param, "_ts_param");
var ChartsController = class {
  static {
    __name(this, "ChartsController");
  }
  getAgeDistribution(timeRange) {
    throw new Error(`method getAgeDistribution not implements`);
  }
  getGenderDistribution(timeRange) {
    throw new Error("method getGenderDistribution not implements");
  }
  getSentimentTrend(timeRange) {
    throw new Error("method getSentimentTrend not implements");
  }
  getGeographic(timeRange) {
    throw new Error("method getGeographic not implements");
  }
  getEventTypes(timeRange) {
    throw new Error("method getEventTypes not implements");
  }
  getWordCloud(timeRange, limit, sentiment) {
    throw new Error("method getWordCloud not implements");
  }
  getEventCountSeries(timeRange) {
    throw new Error("method getEventCountSeries not implements");
  }
  getPostCountSeries(timeRange) {
    throw new Error("method getPostCountSeries not implements");
  }
  getSentimentData(timeRange) {
    throw new Error("method getSentimentData not implements");
  }
  getBatchCharts(timeRange) {
    throw new Error("method getBatchCharts not implements");
  }
};
_ts_decorate([
  Get("age-distribution"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getAgeDistribution", null);
_ts_decorate([
  Get("gender-distribution"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getGenderDistribution", null);
_ts_decorate([
  Get("sentiment-trend"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getSentimentTrend", null);
_ts_decorate([
  Get("geographic"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getGeographic", null);
_ts_decorate([
  Get("event-types"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getEventTypes", null);
_ts_decorate([
  Get("word-cloud"),
  _ts_param(0, Query("timeRange")),
  _ts_param(1, Query("limit")),
  _ts_param(2, Query("sentiment")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange,
    Number,
    String
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getWordCloud", null);
_ts_decorate([
  Get("event-count-series"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getEventCountSeries", null);
_ts_decorate([
  Get("post-count-series"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getPostCountSeries", null);
_ts_decorate([
  Get("sentiment-data"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getSentimentData", null);
_ts_decorate([
  Get("batch"),
  _ts_param(0, Query("timeRange")),
  _ts_metadata("design:type", Function),
  _ts_metadata("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChartsController.prototype, "getBatchCharts", null);
ChartsController = _ts_decorate([
  Controller("charts")
], ChartsController);

// src/controllers/chat.controller.ts
import { Controller as Controller2, Post, Body } from "@sker/core";
function _ts_decorate2(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate2, "_ts_decorate");
function _ts_metadata2(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata2, "_ts_metadata");
function _ts_param2(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param2, "_ts_param");
var ChatController = class {
  static {
    __name(this, "ChatController");
  }
  chat(request) {
    throw new Error("method chat not implements");
  }
};
_ts_decorate2([
  Post("chat"),
  _ts_param2(0, Body()),
  _ts_metadata2("design:type", Function),
  _ts_metadata2("design:paramtypes", [
    typeof ChatRequestDto === "undefined" ? Object : ChatRequestDto
  ]),
  _ts_metadata2("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ChatController.prototype, "chat", null);
ChatController = _ts_decorate2([
  Controller2("chat")
], ChatController);

// src/controllers/claude.controller.ts
import { Controller as Controller3, Get as Get2, Post as Post2, Body as Body2, Query as Query2 } from "@sker/core";
function _ts_decorate3(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate3, "_ts_decorate");
function _ts_metadata3(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata3, "_ts_metadata");
function _ts_param3(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param3, "_ts_param");
var ClaudeController = class {
  static {
    __name(this, "ClaudeController");
  }
  /**
  * 获取所有在线的 CLI 客户端
  * GET /api/claude/clients
  */
  getOnlineClients() {
    throw new Error("This method should be implemented by SDK client proxy");
  }
  /**
  * 获取统计信息
  */
  getStats() {
    throw new Error("This method should be implemented by SDK client proxy");
  }
  /**
  * 获取下一个待执行任务（供 Stop Hook 调用）
  */
  getNextTask(sessionId) {
    throw new Error("This method should be implemented by SDK client proxy");
  }
  /**
  * 添加待执行任务
  */
  addTask(task) {
    throw new Error("This method should be implemented by SDK client proxy");
  }
  /**
  * 获取所有待执行任务
  */
  getTasks() {
    throw new Error("This method should be implemented by SDK client proxy");
  }
  /**
  * 标记任务完成
  */
  completeTask(taskId) {
    throw new Error("This method should be implemented by SDK client proxy");
  }
};
_ts_decorate3([
  Get2("/clients"),
  _ts_metadata3("design:type", Function),
  _ts_metadata3("design:paramtypes", []),
  _ts_metadata3("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ClaudeController.prototype, "getOnlineClients", null);
_ts_decorate3([
  Get2("/stats"),
  _ts_metadata3("design:type", Function),
  _ts_metadata3("design:paramtypes", []),
  _ts_metadata3("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ClaudeController.prototype, "getStats", null);
_ts_decorate3([
  Get2("/tasks/next"),
  _ts_param3(0, Query2("sessionId")),
  _ts_metadata3("design:type", Function),
  _ts_metadata3("design:paramtypes", [
    String
  ]),
  _ts_metadata3("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ClaudeController.prototype, "getNextTask", null);
_ts_decorate3([
  Post2("/tasks"),
  _ts_param3(0, Body2()),
  _ts_metadata3("design:type", Function),
  _ts_metadata3("design:paramtypes", [
    typeof Omit === "undefined" ? Object : Omit
  ]),
  _ts_metadata3("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ClaudeController.prototype, "addTask", null);
_ts_decorate3([
  Get2("/tasks"),
  _ts_metadata3("design:type", Function),
  _ts_metadata3("design:paramtypes", []),
  _ts_metadata3("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ClaudeController.prototype, "getTasks", null);
_ts_decorate3([
  Post2("/tasks/:id/complete"),
  _ts_param3(0, Query2("id")),
  _ts_metadata3("design:type", Function),
  _ts_metadata3("design:paramtypes", [
    String
  ]),
  _ts_metadata3("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ClaudeController.prototype, "completeTask", null);
ClaudeController = _ts_decorate3([
  Controller3("/claude")
], ClaudeController);

// src/controllers/config.controller.ts
import { Controller as Controller4, Get as Get3, Put, Param, Body as Body3 } from "@sker/core";
function _ts_decorate4(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate4, "_ts_decorate");
function _ts_metadata4(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata4, "_ts_metadata");
function _ts_param4(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param4, "_ts_param");
var ConfigController = class {
  static {
    __name(this, "ConfigController");
  }
  /**
  * 获取指定平台的配置
  * @param platform 平台标识
  */
  getConfig(platform) {
    throw new Error("method getConfig not implements");
  }
  /**
  * 更新指定平台的配置
  * @param platform 平台标识
  * @param config 配置数据
  */
  updateConfig(platform, config) {
    throw new Error("method updateConfig not implements");
  }
};
_ts_decorate4([
  Get3(":platform"),
  _ts_param4(0, Param("platform")),
  _ts_metadata4("design:type", Function),
  _ts_metadata4("design:paramtypes", [
    typeof MediaPlatform === "undefined" ? Object : MediaPlatform
  ]),
  _ts_metadata4("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ConfigController.prototype, "getConfig", null);
_ts_decorate4([
  Put(":platform"),
  _ts_param4(0, Param("platform")),
  _ts_param4(1, Body3()),
  _ts_metadata4("design:type", Function),
  _ts_metadata4("design:paramtypes", [
    typeof MediaPlatform === "undefined" ? Object : MediaPlatform,
    Object
  ]),
  _ts_metadata4("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ConfigController.prototype, "updateConfig", null);
ConfigController = _ts_decorate4([
  Controller4("config")
], ConfigController);

// src/controllers/crawler.controller.ts
import { Controller as Controller5, Post as Post3, Get as Get4, Body as Body4, Param as Param2 } from "@sker/core";
function _ts_decorate5(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate5, "_ts_decorate");
function _ts_metadata5(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata5, "_ts_metadata");
function _ts_param5(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param5, "_ts_param");
var CrawlerController = class {
  static {
    __name(this, "CrawlerController");
  }
  /**
  * 启动爬虫任务
  * @param request 爬虫启动请求参数
  */
  start(request) {
    throw new Error("method start not implements");
  }
  /**
  * 获取爬虫任务状态
  * @param id 任务 ID
  */
  getStatus(id) {
    throw new Error("method getStatus not implements");
  }
  /**
  * 停止爬虫任务
  * @param id 任务 ID
  */
  stop(id) {
    throw new Error("method stop not implements");
  }
  /**
  * 获取所有爬虫任务列表
  */
  list() {
    throw new Error("method list not implements");
  }
};
_ts_decorate5([
  Post3("start"),
  _ts_param5(0, Body4()),
  _ts_metadata5("design:type", Function),
  _ts_metadata5("design:paramtypes", [
    typeof CrawlerStartRequest === "undefined" ? Object : CrawlerStartRequest
  ]),
  _ts_metadata5("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], CrawlerController.prototype, "start", null);
_ts_decorate5([
  Get4("status/:id"),
  _ts_param5(0, Param2("id")),
  _ts_metadata5("design:type", Function),
  _ts_metadata5("design:paramtypes", [
    String
  ]),
  _ts_metadata5("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], CrawlerController.prototype, "getStatus", null);
_ts_decorate5([
  Post3("stop/:id"),
  _ts_param5(0, Param2("id")),
  _ts_metadata5("design:type", Function),
  _ts_metadata5("design:paramtypes", [
    String
  ]),
  _ts_metadata5("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], CrawlerController.prototype, "stop", null);
_ts_decorate5([
  Get4("list"),
  _ts_metadata5("design:type", Function),
  _ts_metadata5("design:paramtypes", []),
  _ts_metadata5("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], CrawlerController.prototype, "list", null);
CrawlerController = _ts_decorate5([
  Controller5("crawler")
], CrawlerController);

// src/controllers/derived-node.controller.ts
import { Controller as Controller6, Post as Post4, Body as Body5, Get as Get5, Put as Put2, Param as Param3 } from "@sker/core";
function _ts_decorate6(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate6, "_ts_decorate");
function _ts_metadata6(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata6, "_ts_metadata");
function _ts_param6(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param6, "_ts_param");
var DerivedNodeController = class {
  static {
    __name(this, "DerivedNodeController");
  }
  create(body) {
    throw new Error("method create not implements");
  }
  publish(id) {
    throw new Error("method publish not implements");
  }
  list() {
    throw new Error("method list not implements");
  }
};
_ts_decorate6([
  Post4("/"),
  _ts_param6(0, Body5()),
  _ts_metadata6("design:type", Function),
  _ts_metadata6("design:paramtypes", [
    typeof CreateDerivedNodePayload === "undefined" ? Object : CreateDerivedNodePayload
  ]),
  _ts_metadata6("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], DerivedNodeController.prototype, "create", null);
_ts_decorate6([
  Put2("/:id/publish"),
  _ts_param6(0, Param3("id")),
  _ts_metadata6("design:type", Function),
  _ts_metadata6("design:paramtypes", [
    String
  ]),
  _ts_metadata6("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], DerivedNodeController.prototype, "publish", null);
_ts_decorate6([
  Get5("/"),
  _ts_metadata6("design:type", Function),
  _ts_metadata6("design:paramtypes", []),
  _ts_metadata6("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], DerivedNodeController.prototype, "list", null);
DerivedNodeController = _ts_decorate6([
  Controller6("derived-nodes")
], DerivedNodeController);

// src/controllers/event-statistics.controller.ts
import { Controller as Controller7, Get as Get6, Post as Post5, Query as Query3, Body as Body6 } from "@sker/core";
function _ts_decorate7(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate7, "_ts_decorate");
function _ts_metadata7(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata7, "_ts_metadata");
function _ts_param7(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param7, "_ts_param");
var EventStatisticsController = class {
  static {
    __name(this, "EventStatisticsController");
  }
  /**
  * 手动触发小时级统计生成
  * @deprecated 小时级统计由订阅器自动生成，无需手动触发
  */
  triggerHourlyGeneration(body) {
    throw new Error("method triggerHourlyGeneration not implements");
  }
  /**
  * 手动触发天级统计生成
  * @deprecated 日级统计通过查询API按需聚合，无需手动生成
  */
  triggerDailyGeneration(body) {
    throw new Error("method triggerDailyGeneration not implements");
  }
  /**
  * 回填历史数据
  * @deprecated 历史数据回填已废弃，小时级统计由订阅器自动生成
  */
  backfillHistoricalData(body) {
    throw new Error("method backfillHistoricalData not implements");
  }
  /**
  * 查询事件统计数据
  * 数据来源：event_hourly_statistics 表
  * 支持多粒度聚合：hourly(直接查询)、daily(按天聚合)、weekly(按周聚合)、monthly(按月聚合)
  */
  queryStatistics(eventId, granularity, startTime, endTime) {
    throw new Error("method queryStatistics not implements");
  }
};
_ts_decorate7([
  Post5("generate/hourly"),
  _ts_param7(0, Body6()),
  _ts_metadata7("design:type", Function),
  _ts_metadata7("design:paramtypes", [
    typeof TriggerGenerationRequest === "undefined" ? Object : TriggerGenerationRequest
  ]),
  _ts_metadata7("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventStatisticsController.prototype, "triggerHourlyGeneration", null);
_ts_decorate7([
  Post5("generate/daily"),
  _ts_param7(0, Body6()),
  _ts_metadata7("design:type", Function),
  _ts_metadata7("design:paramtypes", [
    typeof TriggerGenerationRequest === "undefined" ? Object : TriggerGenerationRequest
  ]),
  _ts_metadata7("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventStatisticsController.prototype, "triggerDailyGeneration", null);
_ts_decorate7([
  Post5("backfill"),
  _ts_param7(0, Body6()),
  _ts_metadata7("design:type", Function),
  _ts_metadata7("design:paramtypes", [
    typeof BackfillRequest === "undefined" ? Object : BackfillRequest
  ]),
  _ts_metadata7("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventStatisticsController.prototype, "backfillHistoricalData", null);
_ts_decorate7([
  Get6("query"),
  _ts_param7(0, Query3("eventId")),
  _ts_param7(1, Query3("granularity")),
  _ts_param7(2, Query3("startTime")),
  _ts_param7(3, Query3("endTime")),
  _ts_metadata7("design:type", Function),
  _ts_metadata7("design:paramtypes", [
    String,
    String,
    String,
    String
  ]),
  _ts_metadata7("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventStatisticsController.prototype, "queryStatistics", null);
EventStatisticsController = _ts_decorate7([
  Controller7("event-statistics")
], EventStatisticsController);

// src/controllers/events.controller.ts
import { Controller as Controller8, Get as Get7, Query as Query4, Param as Param4 } from "@sker/core";
function _ts_decorate8(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate8, "_ts_decorate");
function _ts_metadata8(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata8, "_ts_metadata");
function _ts_param8(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param8, "_ts_param");
var EventsController = class {
  static {
    __name(this, "EventsController");
  }
  getEventList(timeRange, page, pageSize, search, category, lambda) {
    console.log({
      timeRange,
      page,
      pageSize,
      search,
      category,
      lambda
    });
    throw new Error("method getEventList not implements");
  }
  getEventCategories(timeRange) {
    throw new Error("method getEventCategories not implements");
  }
  getTrendData(timeRange) {
    throw new Error("method getTrendData not implements");
  }
  getHotList(timeRange) {
    throw new Error("method getHotList not implements");
  }
  getEventTimeSeries(id) {
    throw new Error("method getEventTimeSeries not implements");
  }
  getEventTrends(id) {
    throw new Error("method getEventTrends not implements");
  }
  getInfluenceUsers(id) {
    throw new Error("method getInfluenceUsers not implements");
  }
  getEventGeographic(id) {
    throw new Error("method getEventGeographic not implements");
  }
  getEventKeywords(id, limit) {
    throw new Error("method getEventKeywords not implements");
  }
  getEventDetail(id) {
    throw new Error("method getEventDetail not implements");
  }
  // 新增：NLP 深度分析接口
  getSentimentHotness(id) {
    throw new Error("method getSentimentHotness not implements");
  }
  getSentimentDistribution(id) {
    throw new Error("method getSentimentDistribution not implements");
  }
  getSentimentIntensity(id) {
    throw new Error("method getSentimentIntensity not implements");
  }
  getKeywordsTimeSeries(id, topN) {
    throw new Error("method getKeywordsTimeSeries not implements");
  }
  getKeywordsBySentiment(id) {
    throw new Error("method getKeywordsBySentiment not implements");
  }
  getNegativeKeywords(id, threshold) {
    throw new Error("method getNegativeKeywords not implements");
  }
  getEventTypes(id) {
    throw new Error("method getEventTypes not implements");
  }
  // 新增：基于 EventHourlyStatisticsEntity 的互动指标接口
  getEngagementTrend(id, limit) {
    throw new Error("method getEngagementTrend not implements");
  }
  getAnomalies(id, limit) {
    throw new Error("method getAnomalies not implements");
  }
  getPeaks(id, limit) {
    throw new Error("method getPeaks not implements");
  }
  getEventUserRelations(id) {
    throw new Error("method getEventUserRelations not implements");
  }
};
_ts_decorate8([
  Get7("list"),
  _ts_param8(0, Query4("timeRange")),
  _ts_param8(1, Query4("page")),
  _ts_param8(2, Query4("pageSize")),
  _ts_param8(3, Query4("search")),
  _ts_param8(4, Query4("category")),
  _ts_param8(5, Query4("lambda")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange,
    Number,
    Number,
    String,
    String,
    Number
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventList", null);
_ts_decorate8([
  Get7("categories"),
  _ts_param8(0, Query4("timeRange")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventCategories", null);
_ts_decorate8([
  Get7("trend-data"),
  _ts_param8(0, Query4("timeRange")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getTrendData", null);
_ts_decorate8([
  Get7("hot-list"),
  _ts_param8(0, Query4("timeRange")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getHotList", null);
_ts_decorate8([
  Get7(":id/timeseries"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventTimeSeries", null);
_ts_decorate8([
  Get7(":id/trends"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventTrends", null);
_ts_decorate8([
  Get7(":id/influence-users"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getInfluenceUsers", null);
_ts_decorate8([
  Get7(":id/geographic"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventGeographic", null);
_ts_decorate8([
  Get7(":id/keywords"),
  _ts_param8(0, Param4("id")),
  _ts_param8(1, Query4("limit")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventKeywords", null);
_ts_decorate8([
  Get7(":id"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventDetail", null);
_ts_decorate8([
  Get7(":id/sentiment-hotness"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getSentimentHotness", null);
_ts_decorate8([
  Get7(":id/sentiment-distribution"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getSentimentDistribution", null);
_ts_decorate8([
  Get7(":id/sentiment-intensity"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getSentimentIntensity", null);
_ts_decorate8([
  Get7(":id/keywords-timeseries"),
  _ts_param8(0, Param4("id")),
  _ts_param8(1, Query4("topN")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getKeywordsTimeSeries", null);
_ts_decorate8([
  Get7(":id/keywords-by-sentiment"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getKeywordsBySentiment", null);
_ts_decorate8([
  Get7(":id/negative-keywords"),
  _ts_param8(0, Param4("id")),
  _ts_param8(1, Query4("threshold")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getNegativeKeywords", null);
_ts_decorate8([
  Get7(":id/event-types"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventTypes", null);
_ts_decorate8([
  Get7(":id/engagement-trend"),
  _ts_param8(0, Param4("id")),
  _ts_param8(1, Query4("limit")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEngagementTrend", null);
_ts_decorate8([
  Get7(":id/anomalies"),
  _ts_param8(0, Param4("id")),
  _ts_param8(1, Query4("limit")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getAnomalies", null);
_ts_decorate8([
  Get7(":id/peaks"),
  _ts_param8(0, Param4("id")),
  _ts_param8(1, Query4("limit")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getPeaks", null);
_ts_decorate8([
  Get7(":id/user-relations"),
  _ts_param8(0, Param4("id")),
  _ts_metadata8("design:type", Function),
  _ts_metadata8("design:paramtypes", [
    String
  ]),
  _ts_metadata8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], EventsController.prototype, "getEventUserRelations", null);
EventsController = _ts_decorate8([
  Controller8("events")
], EventsController);

// src/controllers/keywords.controller.ts
import { Controller as Controller9, Get as Get8, Query as Query5 } from "@sker/core";
function _ts_decorate9(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate9, "_ts_decorate");
function _ts_metadata9(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata9, "_ts_metadata");
function _ts_param9(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param9, "_ts_param");
var KeywordsController = class {
  static {
    __name(this, "KeywordsController");
  }
  getWordCloud(maxWords, sentiment) {
    throw new Error("method getWordCloud not implements");
  }
};
_ts_decorate9([
  Get8("wordcloud"),
  _ts_param9(0, Query5("maxWords")),
  _ts_param9(1, Query5("sentiment")),
  _ts_metadata9("design:type", Function),
  _ts_metadata9("design:paramtypes", [
    Number,
    String
  ]),
  _ts_metadata9("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], KeywordsController.prototype, "getWordCloud", null);
KeywordsController = _ts_decorate9([
  Controller9("keywords")
], KeywordsController);

// src/controllers/layout.controller.ts
import { Controller as Controller10, Get as Get9, Post as Post6, Put as Put3, Delete, Query as Query6, Param as Param5, Body as Body7 } from "@sker/core";
function _ts_decorate10(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate10, "_ts_decorate");
function _ts_metadata10(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata10, "_ts_metadata");
function _ts_param10(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param10, "_ts_param");
var LayoutController = class {
  static {
    __name(this, "LayoutController");
  }
  getLayouts(type) {
    throw new Error("method getLayouts not implements");
  }
  getDefaultLayout(type) {
    throw new Error("method getDefaultLayout not implements");
  }
  getLayoutById(id) {
    throw new Error("method getLayoutById not implements");
  }
  createLayout(payload) {
    throw new Error("method createLayout not implements");
  }
  updateLayout(id, payload) {
    throw new Error("method updateLayout not implements");
  }
  deleteLayout(id) {
    throw new Error("method deleteLayout not implements");
  }
  setDefaultLayout(id, type) {
    throw new Error("method setDefaultLayout not implements");
  }
};
_ts_decorate10([
  Get9("/list"),
  _ts_param10(0, Query6("type")),
  _ts_metadata10("design:type", Function),
  _ts_metadata10("design:paramtypes", [
    String
  ]),
  _ts_metadata10("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LayoutController.prototype, "getLayouts", null);
_ts_decorate10([
  Get9("default"),
  _ts_param10(0, Query6("type")),
  _ts_metadata10("design:type", Function),
  _ts_metadata10("design:paramtypes", [
    String
  ]),
  _ts_metadata10("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LayoutController.prototype, "getDefaultLayout", null);
_ts_decorate10([
  Get9(":id"),
  _ts_param10(0, Param5("id")),
  _ts_metadata10("design:type", Function),
  _ts_metadata10("design:paramtypes", [
    String
  ]),
  _ts_metadata10("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LayoutController.prototype, "getLayoutById", null);
_ts_decorate10([
  Post6(),
  _ts_param10(0, Body7()),
  _ts_metadata10("design:type", Function),
  _ts_metadata10("design:paramtypes", [
    typeof CreateLayoutPayload === "undefined" ? Object : CreateLayoutPayload
  ]),
  _ts_metadata10("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LayoutController.prototype, "createLayout", null);
_ts_decorate10([
  Put3(":id"),
  _ts_param10(0, Param5("id")),
  _ts_param10(1, Body7()),
  _ts_metadata10("design:type", Function),
  _ts_metadata10("design:paramtypes", [
    String,
    typeof UpdateLayoutPayload === "undefined" ? Object : UpdateLayoutPayload
  ]),
  _ts_metadata10("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LayoutController.prototype, "updateLayout", null);
_ts_decorate10([
  Delete(":id"),
  _ts_param10(0, Param5("id")),
  _ts_metadata10("design:type", Function),
  _ts_metadata10("design:paramtypes", [
    String
  ]),
  _ts_metadata10("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LayoutController.prototype, "deleteLayout", null);
_ts_decorate10([
  Put3(":id/set-default"),
  _ts_param10(0, Param5("id")),
  _ts_param10(1, Body7("type")),
  _ts_metadata10("design:type", Function),
  _ts_metadata10("design:paramtypes", [
    String,
    String
  ]),
  _ts_metadata10("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LayoutController.prototype, "setDefaultLayout", null);
LayoutController = _ts_decorate10([
  Controller10("layout")
], LayoutController);

// src/controllers/llm-chat-logs.controller.ts
import { Controller as Controller11, Get as Get10, Query as Query7 } from "@sker/core";
function _ts_decorate11(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate11, "_ts_decorate");
function _ts_metadata11(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata11, "_ts_metadata");
function _ts_param11(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param11, "_ts_param");
var LlmChatLogsController = class {
  static {
    __name(this, "LlmChatLogsController");
  }
  getStats(startDate, endDate, granularity) {
    throw new Error("method getStats not implements");
  }
  list(startDate, endDate, modelName, providerId, isSuccess, page, pageSize) {
    throw new Error("method list not implements");
  }
  analyzePrompts(startDate, endDate, modelName, providerId) {
    throw new Error("method analyzePrompts not implements");
  }
};
_ts_decorate11([
  Get10("stats"),
  _ts_param11(0, Query7("startDate")),
  _ts_param11(1, Query7("endDate")),
  _ts_param11(2, Query7("granularity")),
  _ts_metadata11("design:type", Function),
  _ts_metadata11("design:paramtypes", [
    String,
    String,
    String
  ]),
  _ts_metadata11("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmChatLogsController.prototype, "getStats", null);
_ts_decorate11([
  Get10("/list"),
  _ts_param11(0, Query7("startDate")),
  _ts_param11(1, Query7("endDate")),
  _ts_param11(2, Query7("modelName")),
  _ts_param11(3, Query7("providerId")),
  _ts_param11(4, Query7("isSuccess")),
  _ts_param11(5, Query7("page")),
  _ts_param11(6, Query7("pageSize")),
  _ts_metadata11("design:type", Function),
  _ts_metadata11("design:paramtypes", [
    String,
    String,
    String,
    String,
    String,
    String,
    String
  ]),
  _ts_metadata11("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmChatLogsController.prototype, "list", null);
_ts_decorate11([
  Get10("analyze-prompts"),
  _ts_param11(0, Query7("startDate")),
  _ts_param11(1, Query7("endDate")),
  _ts_param11(2, Query7("modelName")),
  _ts_param11(3, Query7("providerId")),
  _ts_metadata11("design:type", Function),
  _ts_metadata11("design:paramtypes", [
    String,
    String,
    String,
    String
  ]),
  _ts_metadata11("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmChatLogsController.prototype, "analyzePrompts", null);
LlmChatLogsController = _ts_decorate11([
  Controller11("llm-chat-logs")
], LlmChatLogsController);

// src/controllers/llm-model-providers.controller.ts
import { Controller as Controller12, Get as Get11, Post as Post7, Put as Put4, Body as Body8, Param as Param6, Query as Query8 } from "@sker/core";
function _ts_decorate12(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate12, "_ts_decorate");
function _ts_metadata12(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata12, "_ts_metadata");
function _ts_param12(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param12, "_ts_param");
var LlmModelProvidersController = class {
  static {
    __name(this, "LlmModelProvidersController");
  }
  findAll() {
    throw new Error("method findAll not implements");
  }
  findByModel(modelId) {
    throw new Error("method findByModel not implements");
  }
  findByProvider(providerId) {
    throw new Error("method findByProvider not implements");
  }
  findOne(id) {
    throw new Error("method findOne not implements");
  }
  create(dto) {
    throw new Error("method create not implements");
  }
  update(id, dto) {
    throw new Error("method update not implements");
  }
  remove(id) {
    throw new Error("method remove not implements");
  }
  enable(id) {
    throw new Error("method enable not implements");
  }
  disable(id) {
    throw new Error("method disable not implements");
  }
};
_ts_decorate12([
  Get11("/list"),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", []),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "findAll", null);
_ts_decorate12([
  Get11("by-model"),
  _ts_param12(0, Query8("modelId")),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    String
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "findByModel", null);
_ts_decorate12([
  Get11("by-provider"),
  _ts_param12(0, Query8("providerId")),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    String
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "findByProvider", null);
_ts_decorate12([
  Get11("get"),
  _ts_param12(0, Query8("id")),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    String
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "findOne", null);
_ts_decorate12([
  Post7("create"),
  _ts_param12(0, Body8()),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    Object
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "create", null);
_ts_decorate12([
  Post7("update"),
  _ts_param12(0, Body8("id")),
  _ts_param12(1, Body8()),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    String,
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "update", null);
_ts_decorate12([
  Post7("remove"),
  _ts_param12(0, Body8("id")),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    String
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "remove", null);
_ts_decorate12([
  Put4(":id/enable"),
  _ts_param12(0, Param6("id")),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    String
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "enable", null);
_ts_decorate12([
  Put4(":id/disable"),
  _ts_param12(0, Param6("id")),
  _ts_metadata12("design:type", Function),
  _ts_metadata12("design:paramtypes", [
    String
  ]),
  _ts_metadata12("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelProvidersController.prototype, "disable", null);
LlmModelProvidersController = _ts_decorate12([
  Controller12("llm-model-providers")
], LlmModelProvidersController);

// src/controllers/llm-models.controller.ts
import { Controller as Controller13, Get as Get12, Post as Post8, Body as Body9, Query as Query9 } from "@sker/core";
function _ts_decorate13(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate13, "_ts_decorate");
function _ts_metadata13(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata13, "_ts_metadata");
function _ts_param13(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param13, "_ts_param");
var LlmModelsController = class {
  static {
    __name(this, "LlmModelsController");
  }
  findAll() {
    throw new Error("method findAll not implements");
  }
  findOne(id) {
    throw new Error("method findOne not implements");
  }
  create(dto) {
    throw new Error("method create not implements");
  }
  update(id, dto) {
    throw new Error("method update not implements");
  }
  remove(id) {
    throw new Error("method remove not implements");
  }
};
_ts_decorate13([
  Get12("list"),
  _ts_metadata13("design:type", Function),
  _ts_metadata13("design:paramtypes", []),
  _ts_metadata13("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelsController.prototype, "findAll", null);
_ts_decorate13([
  Get12("get"),
  _ts_param13(0, Query9("id")),
  _ts_metadata13("design:type", Function),
  _ts_metadata13("design:paramtypes", [
    String
  ]),
  _ts_metadata13("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelsController.prototype, "findOne", null);
_ts_decorate13([
  Post8(`create`),
  _ts_param13(0, Body9()),
  _ts_metadata13("design:type", Function),
  _ts_metadata13("design:paramtypes", [
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata13("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelsController.prototype, "create", null);
_ts_decorate13([
  Post8("update"),
  _ts_param13(0, Body9("id")),
  _ts_param13(1, Body9()),
  _ts_metadata13("design:type", Function),
  _ts_metadata13("design:paramtypes", [
    String,
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata13("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelsController.prototype, "update", null);
_ts_decorate13([
  Post8("remove"),
  _ts_param13(0, Body9("id")),
  _ts_metadata13("design:type", Function),
  _ts_metadata13("design:paramtypes", [
    String
  ]),
  _ts_metadata13("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmModelsController.prototype, "remove", null);
LlmModelsController = _ts_decorate13([
  Controller13("llm-models")
], LlmModelsController);

// src/controllers/llm-providers.controller.ts
import { Controller as Controller14, Get as Get13, Post as Post9, Body as Body10, Param as Param7, Query as Query10 } from "@sker/core";
function _ts_decorate14(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate14, "_ts_decorate");
function _ts_metadata14(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata14, "_ts_metadata");
function _ts_param14(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param14, "_ts_param");
var LlmProvidersController = class {
  static {
    __name(this, "LlmProvidersController");
  }
  findAll() {
    throw new Error("method findAll not implements");
  }
  findOne(id) {
    throw new Error("method findOne not implements");
  }
  create(createLlmProviderDto) {
    throw new Error("method create not implements");
  }
  update(id, updateLlmProviderDto) {
    throw new Error("method update not implements");
  }
  remove(id) {
    throw new Error("method remove not implements");
  }
  getBestProvider() {
    throw new Error("method getBestProvider not implements");
  }
  updateScore(id, score) {
    throw new Error("method updateScore not implements");
  }
};
_ts_decorate14([
  Get13("/list"),
  _ts_metadata14("design:type", Function),
  _ts_metadata14("design:paramtypes", []),
  _ts_metadata14("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmProvidersController.prototype, "findAll", null);
_ts_decorate14([
  Get13(":id"),
  _ts_param14(0, Param7("id")),
  _ts_metadata14("design:type", Function),
  _ts_metadata14("design:paramtypes", [
    String
  ]),
  _ts_metadata14("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmProvidersController.prototype, "findOne", null);
_ts_decorate14([
  Post9("create"),
  _ts_param14(0, Body10()),
  _ts_metadata14("design:type", Function),
  _ts_metadata14("design:paramtypes", [
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata14("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmProvidersController.prototype, "create", null);
_ts_decorate14([
  Post9("update"),
  _ts_param14(0, Query10("id")),
  _ts_param14(1, Body10()),
  _ts_metadata14("design:type", Function),
  _ts_metadata14("design:paramtypes", [
    String,
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata14("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmProvidersController.prototype, "update", null);
_ts_decorate14([
  Post9("remove"),
  _ts_param14(0, Body10("id")),
  _ts_metadata14("design:type", Function),
  _ts_metadata14("design:paramtypes", [
    String
  ]),
  _ts_metadata14("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmProvidersController.prototype, "remove", null);
_ts_decorate14([
  Get13("available/best"),
  _ts_metadata14("design:type", Function),
  _ts_metadata14("design:paramtypes", []),
  _ts_metadata14("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmProvidersController.prototype, "getBestProvider", null);
_ts_decorate14([
  Post9(":id/score"),
  _ts_param14(0, Param7("id")),
  _ts_param14(1, Body10("score")),
  _ts_metadata14("design:type", Function),
  _ts_metadata14("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata14("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LlmProvidersController.prototype, "updateScore", null);
LlmProvidersController = _ts_decorate14([
  Controller14("llm-providers")
], LlmProvidersController);

// src/controllers/llm-proxy.controller.ts
import { Controller as Controller15, Post as Post10, Param as Param8, Body as Body11 } from "@sker/core";
function _ts_decorate15(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate15, "_ts_decorate");
function _ts_metadata15(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata15, "_ts_metadata");
function _ts_param15(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param15, "_ts_param");
var LlmProxyController = class {
  static {
    __name(this, "LlmProxyController");
  }
  proxyMessages(protocol, body) {
    throw new Error("method proxyMessages not implements");
  }
};
_ts_decorate15([
  Post10(":protocol/**"),
  _ts_param15(0, Param8("protocol")),
  _ts_param15(1, Body11()),
  _ts_metadata15("design:type", Function),
  _ts_metadata15("design:paramtypes", [
    String,
    Object
  ]),
  _ts_metadata15("design:returntype", Object)
], LlmProxyController.prototype, "proxyMessages", null);
LlmProxyController = _ts_decorate15([
  Controller15("llm")
], LlmProxyController);

// src/controllers/login.controller.ts
import { Controller as Controller16, Post as Post11, Get as Get14, Body as Body12, Param as Param9 } from "@sker/core";
function _ts_decorate16(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate16, "_ts_decorate");
function _ts_metadata16(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata16, "_ts_metadata");
function _ts_param16(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param16, "_ts_param");
var LoginController = class {
  static {
    __name(this, "LoginController");
  }
  /**
  * 获取指定平台的二维码登录信息
  * @param platform 平台标识
  */
  getQRCode(platform) {
    throw new Error("method getQRCode not implements");
  }
  /**
  * 获取指定平台的登录状态
  * @param platform 平台标识
  */
  getStatus(platform) {
    throw new Error("method getStatus not implements");
  }
  /**
  * 使用 Cookie 登录指定平台
  * @param platform 平台标识
  * @param request Cookie 登录请求数据
  */
  loginWithCookie(platform, request) {
    throw new Error("method loginWithCookie not implements");
  }
};
_ts_decorate16([
  Post11(":platform/qrcode"),
  _ts_param16(0, Param9("platform")),
  _ts_metadata16("design:type", Function),
  _ts_metadata16("design:paramtypes", [
    typeof MediaPlatform === "undefined" ? Object : MediaPlatform
  ]),
  _ts_metadata16("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LoginController.prototype, "getQRCode", null);
_ts_decorate16([
  Get14(":platform/status"),
  _ts_param16(0, Param9("platform")),
  _ts_metadata16("design:type", Function),
  _ts_metadata16("design:paramtypes", [
    typeof MediaPlatform === "undefined" ? Object : MediaPlatform
  ]),
  _ts_metadata16("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LoginController.prototype, "getStatus", null);
_ts_decorate16([
  Post11(":platform/cookie"),
  _ts_param16(0, Param9("platform")),
  _ts_param16(1, Body12()),
  _ts_metadata16("design:type", Function),
  _ts_metadata16("design:paramtypes", [
    typeof MediaPlatform === "undefined" ? Object : MediaPlatform,
    typeof CookieLoginRequest === "undefined" ? Object : CookieLoginRequest
  ]),
  _ts_metadata16("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], LoginController.prototype, "loginWithCookie", null);
LoginController = _ts_decorate16([
  Controller16("login")
], LoginController);

// src/controllers/overview.controller.ts
import { Controller as Controller17, Get as Get15, Query as Query11, ApiDescription } from "@sker/core";
function _ts_decorate17(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate17, "_ts_decorate");
function _ts_metadata17(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata17, "_ts_metadata");
function _ts_param17(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param17, "_ts_param");
var OverviewController = class {
  static {
    __name(this, "OverviewController");
  }
  getStatistics(timeRange) {
    throw new Error("method getStatistics not implements");
  }
  getSentiment(timeRange) {
    throw new Error("method getSentiment not implements");
  }
  getLocations(timeRange) {
    throw new Error("method getLocations not implements");
  }
};
_ts_decorate17([
  Get15("statistics"),
  ApiDescription(``, [
    "overview"
  ]),
  _ts_param17(0, Query11("timeRange")),
  _ts_metadata17("design:type", Function),
  _ts_metadata17("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata17("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], OverviewController.prototype, "getStatistics", null);
_ts_decorate17([
  Get15("sentiment"),
  _ts_param17(0, Query11("timeRange")),
  _ts_metadata17("design:type", Function),
  _ts_metadata17("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata17("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], OverviewController.prototype, "getSentiment", null);
_ts_decorate17([
  Get15("locations"),
  _ts_param17(0, Query11("timeRange")),
  _ts_metadata17("design:type", Function),
  _ts_metadata17("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata17("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], OverviewController.prototype, "getLocations", null);
OverviewController = _ts_decorate17([
  Controller17("overview")
], OverviewController);

// src/controllers/posts.controller.ts
import { Controller as Controller18, Get as Get16, Query as Query12 } from "@sker/core";
function _ts_decorate18(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate18, "_ts_decorate");
function _ts_metadata18(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata18, "_ts_metadata");
function _ts_param18(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param18, "_ts_param");
var PostsController = class {
  static {
    __name(this, "PostsController");
  }
  /**
  * 获取待 NLP 处理的帖子列表
  * 用于浏览器端工作流执行器
  */
  getPendingNLPPosts(cursor, pageSize) {
    throw new Error("method getPendingNLPPosts not implements");
  }
};
_ts_decorate18([
  Get16("pending-nlp"),
  _ts_param18(0, Query12("cursor")),
  _ts_param18(1, Query12("pageSize")),
  _ts_metadata18("design:type", Function),
  _ts_metadata18("design:paramtypes", [
    String,
    Number
  ]),
  _ts_metadata18("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PostsController.prototype, "getPendingNLPPosts", null);
PostsController = _ts_decorate18([
  Controller18("posts")
], PostsController);

// src/controllers/proxy.controller.ts
import { Controller as Controller19, Get as Get17, Query as Query13 } from "@sker/core";
function _ts_decorate19(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate19, "_ts_decorate");
function _ts_metadata19(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata19, "_ts_metadata");
function _ts_param19(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param19, "_ts_param");
var ProxyController = class {
  static {
    __name(this, "ProxyController");
  }
  proxyQRCode(url) {
    throw new Error("method proxyQRCode not implements");
  }
};
_ts_decorate19([
  Get17("qrcode"),
  _ts_param19(0, Query13("url")),
  _ts_metadata19("design:type", Function),
  _ts_metadata19("design:paramtypes", [
    String
  ]),
  _ts_metadata19("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], ProxyController.prototype, "proxyQRCode", null);
ProxyController = _ts_decorate19([
  Controller19("proxy")
], ProxyController);

// src/controllers/sentiment.controller.ts
import { Controller as Controller20, Get as Get18, Post as Post12, Query as Query14, Body as Body13 } from "@sker/core";
function _ts_decorate20(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate20, "_ts_decorate");
function _ts_metadata20(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata20, "_ts_metadata");
function _ts_param20(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param20, "_ts_param");
var SentimentController = class {
  static {
    __name(this, "SentimentController");
  }
  getRealtimeData(timeRange = "12h") {
    throw new Error("method getRealtimeData not implements");
  }
  getStatistics(timeRange = "12h") {
    throw new Error("method getStatistics not implements");
  }
  getHotTopics(timeRange) {
    throw new Error("method getHotTopics not implements");
  }
  getKeywords(timeRange) {
    throw new Error("method getKeywords not implements");
  }
  getTimeSeries(timeRange) {
    throw new Error("method getTimeSeries not implements");
  }
  getLocations(timeRange) {
    throw new Error("method getLocations not implements");
  }
  getRecentPosts(timeRange) {
    throw new Error("method getRecentPosts not implements");
  }
  search(searchData) {
    throw new Error("method search not implements");
  }
};
_ts_decorate20([
  Get18("realtime"),
  _ts_param20(0, Query14("timeRange")),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "getRealtimeData", null);
_ts_decorate20([
  Get18("statistics"),
  _ts_param20(0, Query14("timeRange")),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "getStatistics", null);
_ts_decorate20([
  Get18("hot-topics"),
  _ts_param20(0, Query14("timeRange")),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "getHotTopics", null);
_ts_decorate20([
  Get18("keywords"),
  _ts_param20(0, Query14("timeRange")),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "getKeywords", null);
_ts_decorate20([
  Get18("time-series"),
  _ts_param20(0, Query14("timeRange")),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "getTimeSeries", null);
_ts_decorate20([
  Get18("locations"),
  _ts_param20(0, Query14("timeRange")),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "getLocations", null);
_ts_decorate20([
  Get18("recent-posts"),
  _ts_param20(0, Query14("timeRange")),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "getRecentPosts", null);
_ts_decorate20([
  Post12("search"),
  _ts_param20(0, Body13()),
  _ts_metadata20("design:type", Function),
  _ts_metadata20("design:paramtypes", [
    Object
  ]),
  _ts_metadata20("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SentimentController.prototype, "search", null);
SentimentController = _ts_decorate20([
  Controller20("sentiment")
], SentimentController);

// src/controllers/system.controller.ts
import { Controller as Controller21, Get as Get19 } from "@sker/core";
function _ts_decorate21(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate21, "_ts_decorate");
function _ts_metadata21(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata21, "_ts_metadata");
var SystemController = class {
  static {
    __name(this, "SystemController");
  }
  getSystemStatus() {
    throw new Error("method getSystemStatus not implements");
  }
  getPerformance() {
    throw new Error("method getPerformance not implements");
  }
  getHealth() {
    throw new Error("method getHealth not implements");
  }
};
_ts_decorate21([
  Get19("status"),
  _ts_metadata21("design:type", Function),
  _ts_metadata21("design:paramtypes", []),
  _ts_metadata21("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SystemController.prototype, "getSystemStatus", null);
_ts_decorate21([
  Get19("performance"),
  _ts_metadata21("design:type", Function),
  _ts_metadata21("design:paramtypes", []),
  _ts_metadata21("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SystemController.prototype, "getPerformance", null);
_ts_decorate21([
  Get19("health"),
  _ts_metadata21("design:type", Function),
  _ts_metadata21("design:paramtypes", []),
  _ts_metadata21("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], SystemController.prototype, "getHealth", null);
SystemController = _ts_decorate21([
  Controller21("system")
], SystemController);

// src/controllers/upload.controller.ts
import { Controller as Controller22, Post as Post13, Body as Body14 } from "@sker/core";
function _ts_decorate22(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate22, "_ts_decorate");
function _ts_metadata22(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata22, "_ts_metadata");
function _ts_param21(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param21, "_ts_param");
var UploadController = class {
  static {
    __name(this, "UploadController");
  }
  uploadFile(formData) {
    throw new Error("method uploadFile not implements");
  }
  uploadBase64(body) {
    throw new Error("method uploadBase64 not implements");
  }
};
_ts_decorate22([
  Post13("file"),
  _ts_param21(0, Body14()),
  _ts_metadata22("design:type", Function),
  _ts_metadata22("design:paramtypes", [
    typeof FormData === "undefined" ? Object : FormData
  ]),
  _ts_metadata22("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], UploadController.prototype, "uploadFile", null);
_ts_decorate22([
  Post13("base64"),
  _ts_param21(0, Body14()),
  _ts_metadata22("design:type", Function),
  _ts_metadata22("design:paramtypes", [
    typeof UploadBase64Request === "undefined" ? Object : UploadBase64Request
  ]),
  _ts_metadata22("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], UploadController.prototype, "uploadBase64", null);
UploadController = _ts_decorate22([
  Controller22("upload")
], UploadController);

// src/controllers/user-relation.controller.ts
import { Controller as Controller23, Get as Get20, Query as Query15 } from "@sker/core";
function _ts_decorate23(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate23, "_ts_decorate");
function _ts_metadata23(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata23, "_ts_metadata");
function _ts_param22(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param22, "_ts_param");
var UserRelationController = class {
  static {
    __name(this, "UserRelationController");
  }
  getNetwork(type, timeRange, minWeight, limit) {
    throw new Error("method getNetwork not implements");
  }
};
_ts_decorate23([
  Get20("list"),
  _ts_param22(0, Query15("type")),
  _ts_param22(1, Query15("timeRange")),
  _ts_param22(2, Query15("minWeight")),
  _ts_param22(3, Query15("limit")),
  _ts_metadata23("design:type", Function),
  _ts_metadata23("design:paramtypes", [
    typeof UserRelationType === "undefined" ? Object : UserRelationType,
    typeof TimeRange === "undefined" ? Object : TimeRange,
    Number,
    Number
  ]),
  _ts_metadata23("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], UserRelationController.prototype, "getNetwork", null);
UserRelationController = _ts_decorate23([
  Controller23("user-relations")
], UserRelationController);

// src/controllers/users.controller.ts
import { Controller as Controller24, Get as Get21, Query as Query16 } from "@sker/core";
function _ts_decorate24(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate24, "_ts_decorate");
function _ts_metadata24(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata24, "_ts_metadata");
function _ts_param23(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param23, "_ts_param");
var UsersController = class {
  static {
    __name(this, "UsersController");
  }
  getUserList(timeRange, page, pageSize) {
    throw new Error("method getUserList not implements");
  }
  getRiskLevels(timeRange) {
    throw new Error("method getRiskLevels not implements");
  }
  getStatistics(timeRange) {
    throw new Error("method getStatistics not implements");
  }
};
_ts_decorate24([
  Get21("list"),
  _ts_param23(0, Query16("timeRange")),
  _ts_param23(1, Query16("page")),
  _ts_param23(2, Query16("pageSize")),
  _ts_metadata24("design:type", Function),
  _ts_metadata24("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange,
    Number,
    Number
  ]),
  _ts_metadata24("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], UsersController.prototype, "getUserList", null);
_ts_decorate24([
  Get21("risk-levels"),
  _ts_param23(0, Query16("timeRange")),
  _ts_metadata24("design:type", Function),
  _ts_metadata24("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata24("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], UsersController.prototype, "getRiskLevels", null);
_ts_decorate24([
  Get21("statistics"),
  _ts_param23(0, Query16("timeRange")),
  _ts_metadata24("design:type", Function),
  _ts_metadata24("design:paramtypes", [
    typeof TimeRange === "undefined" ? Object : TimeRange
  ]),
  _ts_metadata24("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], UsersController.prototype, "getStatistics", null);
UsersController = _ts_decorate24([
  Controller24("users")
], UsersController);

// src/controllers/workflow.controller.ts
import { Controller as Controller25, Post as Post14, Body as Body15, Get as Get22, Query as Query17, Delete as Delete2, Put as Put5 } from "@sker/core";
import { Observable } from "rxjs";
function _ts_decorate25(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate25, "_ts_decorate");
function _ts_metadata25(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata25, "_ts_metadata");
function _ts_param24(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param24, "_ts_param");
var WorkflowController = class {
  static {
    __name(this, "WorkflowController");
  }
  saveWorkflow(body) {
    throw new Error("method saveWorkflow not implements");
  }
  getWorkflow(params) {
    throw new Error("method getWorkflow not implements");
  }
  listWorkflows() {
    throw new Error("method listWorkflows not implements");
  }
  initWorkflow(params) {
    throw new Error("method initWorkflow not implements");
  }
  listTemplates() {
    throw new Error("method listTemplates not implements");
  }
  deleteWorkflow(params) {
    throw new Error("method deleteWorkflow not implements");
  }
  execute(body) {
    throw new Error("method execute not implements");
  }
  /**
  * 创建工作流运行实例
  */
  createRun(body) {
    throw new Error("method createRun not implements");
  }
  /**
  * 执行工作流运行实例
  */
  executeRun(body) {
    throw new Error("method executeRun not implements");
  }
  /**
  * 获取运行实例详情
  */
  getRun(runId) {
    throw new Error("method getRun not implements");
  }
  /**
  * 列出工作流的运行历史
  */
  listRuns(query) {
    throw new Error("method listRuns not implements");
  }
  /**
  * 取消运行实例
  */
  cancelRun(body) {
    throw new Error("method cancelRun not implements");
  }
  // ========== 调度相关方法 ==========
  /**
  * 创建调度
  */
  createSchedule(body) {
    throw new Error("method createSchedule not implements");
  }
  /**
  * 列出调度
  */
  listSchedules(workflowName) {
    throw new Error("method listSchedules not implements");
  }
  /**
  * 获取调度详情
  */
  getSchedule(scheduleId) {
    throw new Error("method getSchedule not implements");
  }
  /**
  * 更新调度
  */
  updateSchedule(scheduleId, body) {
    throw new Error("method updateSchedule not implements");
  }
  /**
  * 删除调度
  */
  deleteSchedule(scheduleId) {
    throw new Error("method deleteSchedule not implements");
  }
  /**
  * 启用调度
  */
  enableSchedule(scheduleId) {
    throw new Error("method enableSchedule not implements");
  }
  /**
  * 禁用调度
  */
  disableSchedule(scheduleId) {
    throw new Error("method disableSchedule not implements");
  }
  /**
  * 手动触发调度
  * 返回 runId，后台异步执行
  */
  triggerSchedule(scheduleId, body) {
    throw new Error("method triggerSchedule not implements");
  }
  /**
  * 执行单个节点 - 微调执行
  */
  executeNode(body) {
    throw new Error("method executeNode not implements");
  }
  /**
  * 节点微调 - 基于响应式流的智能重放
  */
  fineTuneNode(runId, nodeId, body) {
    throw new Error("method fineTuneNode not implements");
  }
  /**
  * 获取所有可用节点类型
  */
  getAvailableNodes() {
    throw new Error("method getAvailableNodes not implements");
  }
};
_ts_decorate25([
  Post14("save"),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    typeof WorkflowGraphAst === "undefined" ? Object : WorkflowGraphAst
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "saveWorkflow", null);
_ts_decorate25([
  Get22("get"),
  _ts_param24(0, Query17()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "getWorkflow", null);
_ts_decorate25([
  Get22("list"),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", []),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "listWorkflows", null);
_ts_decorate25([
  Get22("init"),
  _ts_param24(0, Query17()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "initWorkflow", null);
_ts_decorate25([
  Get22("templates"),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", []),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "listTemplates", null);
_ts_decorate25([
  Delete2("deleteWorkflow"),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "deleteWorkflow", null);
_ts_decorate25([
  Post14({
    path: "execute",
    sse: true
  }),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    typeof ExecuteWorkflowPayload === "undefined" ? Object : ExecuteWorkflowPayload
  ]),
  _ts_metadata25("design:returntype", typeof Observable === "undefined" ? Object : Observable)
], WorkflowController.prototype, "execute", null);
_ts_decorate25([
  Post14("createRun"),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "createRun", null);
_ts_decorate25([
  Post14("executeRun"),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "executeRun", null);
_ts_decorate25([
  Get22("getRun"),
  _ts_param24(0, Query17("runId")),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "getRun", null);
_ts_decorate25([
  Get22("listRuns"),
  _ts_param24(0, Query17()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "listRuns", null);
_ts_decorate25([
  Post14("cancelRun"),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "cancelRun", null);
_ts_decorate25([
  Post14("createSchedule"),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "createSchedule", null);
_ts_decorate25([
  Get22("listSchedules"),
  _ts_param24(0, Query17("name")),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "listSchedules", null);
_ts_decorate25([
  Get22("getSchedule"),
  _ts_param24(0, Query17("scheduleId")),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "getSchedule", null);
_ts_decorate25([
  Put5("updateSchedule"),
  _ts_param24(0, Query17("scheduleId")),
  _ts_param24(1, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String,
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "updateSchedule", null);
_ts_decorate25([
  Post14("deleteSchedule"),
  _ts_param24(0, Body15("scheduleId")),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "deleteSchedule", null);
_ts_decorate25([
  Post14("enableSchedule"),
  _ts_param24(0, Body15("scheduleId")),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "enableSchedule", null);
_ts_decorate25([
  Post14("disableSchedule"),
  _ts_param24(0, Body15("scheduleId")),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "disableSchedule", null);
_ts_decorate25([
  Post14("triggerSchedule"),
  _ts_param24(0, Query17("scheduleId")),
  _ts_param24(1, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String,
    Object
  ]),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "triggerSchedule", null);
_ts_decorate25([
  Post14({
    path: "executeNode",
    sse: true
  }),
  _ts_param24(0, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    typeof ExecuteNodePayload === "undefined" ? Object : ExecuteNodePayload
  ]),
  _ts_metadata25("design:returntype", typeof Observable === "undefined" ? Object : Observable)
], WorkflowController.prototype, "executeNode", null);
_ts_decorate25([
  Post14({
    path: `fineTuneNode`,
    sse: true
  }),
  _ts_param24(0, Query17("runId")),
  _ts_param24(1, Query17("nodeId")),
  _ts_param24(2, Body15()),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", [
    String,
    String,
    typeof FineTunePayload === "undefined" ? Object : FineTunePayload
  ]),
  _ts_metadata25("design:returntype", typeof Observable === "undefined" ? Object : Observable)
], WorkflowController.prototype, "fineTuneNode", null);
_ts_decorate25([
  Get22("getAvailableNodes"),
  _ts_metadata25("design:type", Function),
  _ts_metadata25("design:paramtypes", []),
  _ts_metadata25("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowController.prototype, "getAvailableNodes", null);
WorkflowController = _ts_decorate25([
  Controller25("workflow")
], WorkflowController);

// src/controllers/workflow-dsl.controller.ts
import { Controller as Controller26, Post as Post15, Body as Body16, Get as Get23, Query as Query18 } from "@sker/core";
function _ts_decorate26(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate26, "_ts_decorate");
function _ts_metadata26(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata26, "_ts_metadata");
function _ts_param25(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param25, "_ts_param");
var WorkflowDSLController = class {
  static {
    __name(this, "WorkflowDSLController");
  }
  generate(body) {
    throw new Error("method generate not implements");
  }
  refine(body) {
    throw new Error("method refine not implements");
  }
  compile(body) {
    throw new Error("method compile not implements");
  }
  listNodes(query) {
    throw new Error("method listNodes not implements");
  }
  getNodeSchema(query) {
    throw new Error("method getNodeSchema not implements");
  }
};
_ts_decorate26([
  Post15("/generate"),
  _ts_param25(0, Body16()),
  _ts_metadata26("design:type", Function),
  _ts_metadata26("design:paramtypes", [
    typeof GenerateDSLPayload === "undefined" ? Object : GenerateDSLPayload
  ]),
  _ts_metadata26("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowDSLController.prototype, "generate", null);
_ts_decorate26([
  Post15("/refine"),
  _ts_param25(0, Body16()),
  _ts_metadata26("design:type", Function),
  _ts_metadata26("design:paramtypes", [
    typeof RefineDSLPayload === "undefined" ? Object : RefineDSLPayload
  ]),
  _ts_metadata26("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowDSLController.prototype, "refine", null);
_ts_decorate26([
  Post15("/compile"),
  _ts_param25(0, Body16()),
  _ts_metadata26("design:type", Function),
  _ts_metadata26("design:paramtypes", [
    typeof CompileDSLPayload === "undefined" ? Object : CompileDSLPayload
  ]),
  _ts_metadata26("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowDSLController.prototype, "compile", null);
_ts_decorate26([
  Get23("/nodes"),
  _ts_param25(0, Query18()),
  _ts_metadata26("design:type", Function),
  _ts_metadata26("design:paramtypes", [
    Object
  ]),
  _ts_metadata26("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowDSLController.prototype, "listNodes", null);
_ts_decorate26([
  Get23("/node-schema"),
  _ts_param25(0, Query18()),
  _ts_metadata26("design:type", Function),
  _ts_metadata26("design:paramtypes", [
    Object
  ]),
  _ts_metadata26("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], WorkflowDSLController.prototype, "getNodeSchema", null);
WorkflowDSLController = _ts_decorate26([
  Controller26("workflow-dsl")
], WorkflowDSLController);

// src/controllers/persona.controller.ts
import { Controller as Controller27, Get as Get24, Param as Param10, Post as Post16, Body as Body17 } from "@sker/core";
function _ts_decorate27(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate27, "_ts_decorate");
function _ts_metadata27(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata27, "_ts_metadata");
function _ts_param26(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param26, "_ts_param");
var PersonaController = class {
  static {
    __name(this, "PersonaController");
  }
  getPersonaList() {
    throw new Error("method getPersonaList not implements");
  }
  getMemoryGraph(id) {
    throw new Error("method getMemoryGraph not implements");
  }
  retrieveMemories(request) {
    throw new Error("method retrieveMemories not implements");
  }
  createMemory(id, request) {
    throw new Error("method createMemory not implements");
  }
};
_ts_decorate27([
  Get24("list"),
  _ts_metadata27("design:type", Function),
  _ts_metadata27("design:paramtypes", []),
  _ts_metadata27("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PersonaController.prototype, "getPersonaList", null);
_ts_decorate27([
  Get24(":id/memory-graph"),
  _ts_param26(0, Param10("id")),
  _ts_metadata27("design:type", Function),
  _ts_metadata27("design:paramtypes", [
    String
  ]),
  _ts_metadata27("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PersonaController.prototype, "getMemoryGraph", null);
_ts_decorate27([
  Post16("retrieve-memories"),
  _ts_param26(0, Body17()),
  _ts_metadata27("design:type", Function),
  _ts_metadata27("design:paramtypes", [
    typeof RetrieveMemoriesRequest === "undefined" ? Object : RetrieveMemoriesRequest
  ]),
  _ts_metadata27("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PersonaController.prototype, "retrieveMemories", null);
_ts_decorate27([
  Post16(":id/memories"),
  _ts_param26(0, Param10("id")),
  _ts_param26(1, Body17()),
  _ts_metadata27("design:type", Function),
  _ts_metadata27("design:paramtypes", [
    String,
    typeof Omit === "undefined" ? Object : Omit
  ]),
  _ts_metadata27("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PersonaController.prototype, "createMemory", null);
PersonaController = _ts_decorate27([
  Controller27("personas")
], PersonaController);

// src/controllers/prompt-optimizer.controller.ts
import { Controller as Controller28, Post as Post17, Body as Body18, Get as Get25, Param as Param11, Query as Query19 } from "@sker/core";
import { Observable as Observable2 } from "rxjs";
function _ts_decorate28(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate28, "_ts_decorate");
function _ts_metadata28(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata28, "_ts_metadata");
function _ts_param27(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param27, "_ts_param");
var PromptOptimizerController = class {
  static {
    __name(this, "PromptOptimizerController");
  }
  createTask(body) {
    throw new Error("method createTask not implements");
  }
  getTask(taskId) {
    throw new Error("method getTask not implements");
  }
  listTasks(query) {
    throw new Error("method listTasks not implements");
  }
  executeTask(taskId) {
    throw new Error("method executeTask not implements");
  }
  getVersions(taskId) {
    throw new Error("method getVersions not implements");
  }
  getVersion(taskId, versionId) {
    throw new Error("method getVersion not implements");
  }
  getBestVersion(taskId) {
    throw new Error("method getBestVersion not implements");
  }
  quickOptimize(body) {
    throw new Error("method quickOptimize not implements");
  }
};
_ts_decorate28([
  Post17("/tasks"),
  _ts_param27(0, Body18()),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    typeof CreateOptimizationTaskPayload === "undefined" ? Object : CreateOptimizationTaskPayload
  ]),
  _ts_metadata28("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptOptimizerController.prototype, "createTask", null);
_ts_decorate28([
  Get25("/tasks/:taskId"),
  _ts_param27(0, Param11("taskId")),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    String
  ]),
  _ts_metadata28("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptOptimizerController.prototype, "getTask", null);
_ts_decorate28([
  Get25("/tasks"),
  _ts_param27(0, Query19()),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    Object
  ]),
  _ts_metadata28("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptOptimizerController.prototype, "listTasks", null);
_ts_decorate28([
  Post17({
    path: "/tasks/:taskId/execute",
    sse: true
  }),
  _ts_param27(0, Param11("taskId")),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    String
  ]),
  _ts_metadata28("design:returntype", typeof Observable2 === "undefined" ? Object : Observable2)
], PromptOptimizerController.prototype, "executeTask", null);
_ts_decorate28([
  Get25("/tasks/:taskId/versions"),
  _ts_param27(0, Param11("taskId")),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    String
  ]),
  _ts_metadata28("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptOptimizerController.prototype, "getVersions", null);
_ts_decorate28([
  Get25("/tasks/:taskId/versions/:versionId"),
  _ts_param27(0, Param11("taskId")),
  _ts_param27(1, Param11("versionId")),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    String,
    String
  ]),
  _ts_metadata28("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptOptimizerController.prototype, "getVersion", null);
_ts_decorate28([
  Get25("/tasks/:taskId/best"),
  _ts_param27(0, Param11("taskId")),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    String
  ]),
  _ts_metadata28("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptOptimizerController.prototype, "getBestVersion", null);
_ts_decorate28([
  Post17({
    path: "/quick",
    sse: true
  }),
  _ts_param27(0, Body18()),
  _ts_metadata28("design:type", Function),
  _ts_metadata28("design:paramtypes", [
    typeof QuickOptimizePayload === "undefined" ? Object : QuickOptimizePayload
  ]),
  _ts_metadata28("design:returntype", typeof Observable2 === "undefined" ? Object : Observable2)
], PromptOptimizerController.prototype, "quickOptimize", null);
PromptOptimizerController = _ts_decorate28([
  Controller28("prompt-optimizer")
], PromptOptimizerController);

// src/controllers/prompt-roles.controller.ts
import { Controller as Controller29, Get as Get26, Post as Post18, Put as Put6, Delete as Delete3, Body as Body19, Param as Param12 } from "@sker/core";
function _ts_decorate29(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate29, "_ts_decorate");
function _ts_metadata29(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata29, "_ts_metadata");
function _ts_param28(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param28, "_ts_param");
var PromptRolesController = class {
  static {
    __name(this, "PromptRolesController");
  }
  findAll() {
    throw new Error("method findAll not implements");
  }
  findOne(id) {
    throw new Error("method findOne not implements");
  }
  create(dto) {
    throw new Error("method create not implements");
  }
  update(id, dto) {
    throw new Error("method update not implements");
  }
  remove(id) {
    throw new Error("method remove not implements");
  }
  addSkill(roleId, dto) {
    throw new Error("method addSkill not implements");
  }
  removeSkill(roleId, skillId) {
    throw new Error("method removeSkill not implements");
  }
};
_ts_decorate29([
  Get26("list"),
  _ts_metadata29("design:type", Function),
  _ts_metadata29("design:paramtypes", []),
  _ts_metadata29("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptRolesController.prototype, "findAll", null);
_ts_decorate29([
  Get26(":id"),
  _ts_param28(0, Param12("id")),
  _ts_metadata29("design:type", Function),
  _ts_metadata29("design:paramtypes", [
    String
  ]),
  _ts_metadata29("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptRolesController.prototype, "findOne", null);
_ts_decorate29([
  Post18(),
  _ts_param28(0, Body19()),
  _ts_metadata29("design:type", Function),
  _ts_metadata29("design:paramtypes", [
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata29("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptRolesController.prototype, "create", null);
_ts_decorate29([
  Put6(":id"),
  _ts_param28(0, Param12("id")),
  _ts_param28(1, Body19()),
  _ts_metadata29("design:type", Function),
  _ts_metadata29("design:paramtypes", [
    String,
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata29("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptRolesController.prototype, "update", null);
_ts_decorate29([
  Delete3(":id"),
  _ts_param28(0, Param12("id")),
  _ts_metadata29("design:type", Function),
  _ts_metadata29("design:paramtypes", [
    String
  ]),
  _ts_metadata29("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptRolesController.prototype, "remove", null);
_ts_decorate29([
  Post18(":id/skills"),
  _ts_param28(0, Param12("id")),
  _ts_param28(1, Body19()),
  _ts_metadata29("design:type", Function),
  _ts_metadata29("design:paramtypes", [
    String,
    Object
  ]),
  _ts_metadata29("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptRolesController.prototype, "addSkill", null);
_ts_decorate29([
  Delete3(":id/skills/:skillId"),
  _ts_param28(0, Param12("id")),
  _ts_param28(1, Param12("skillId")),
  _ts_metadata29("design:type", Function),
  _ts_metadata29("design:paramtypes", [
    String,
    String
  ]),
  _ts_metadata29("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptRolesController.prototype, "removeSkill", null);
PromptRolesController = _ts_decorate29([
  Controller29("prompt-roles")
], PromptRolesController);

// src/controllers/prompt-skills.controller.ts
import { Controller as Controller30, Get as Get27, Post as Post19, Put as Put7, Delete as Delete4, Body as Body20, Param as Param13, Query as Query20 } from "@sker/core";
function _ts_decorate30(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate30, "_ts_decorate");
function _ts_metadata30(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata30, "_ts_metadata");
function _ts_param29(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param29, "_ts_param");
var PromptSkillsController = class {
  static {
    __name(this, "PromptSkillsController");
  }
  findAll(type) {
    throw new Error("method findAll not implements");
  }
  findOne(id) {
    throw new Error("method findOne not implements");
  }
  create(dto) {
    throw new Error("method create not implements");
  }
  update(id, dto) {
    throw new Error("method update not implements");
  }
  remove(id) {
    throw new Error("method remove not implements");
  }
};
_ts_decorate30([
  Get27("list"),
  _ts_param29(0, Query20("type")),
  _ts_metadata30("design:type", Function),
  _ts_metadata30("design:paramtypes", [
    typeof PromptSkillType === "undefined" ? Object : PromptSkillType
  ]),
  _ts_metadata30("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptSkillsController.prototype, "findAll", null);
_ts_decorate30([
  Get27(":id"),
  _ts_param29(0, Param13("id")),
  _ts_metadata30("design:type", Function),
  _ts_metadata30("design:paramtypes", [
    String
  ]),
  _ts_metadata30("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptSkillsController.prototype, "findOne", null);
_ts_decorate30([
  Post19(),
  _ts_param29(0, Body20()),
  _ts_metadata30("design:type", Function),
  _ts_metadata30("design:paramtypes", [
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata30("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptSkillsController.prototype, "create", null);
_ts_decorate30([
  Put7(":id"),
  _ts_param29(0, Param13("id")),
  _ts_param29(1, Body20()),
  _ts_metadata30("design:type", Function),
  _ts_metadata30("design:paramtypes", [
    String,
    typeof Partial === "undefined" ? Object : Partial
  ]),
  _ts_metadata30("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptSkillsController.prototype, "update", null);
_ts_decorate30([
  Delete4(":id"),
  _ts_param29(0, Param13("id")),
  _ts_metadata30("design:type", Function),
  _ts_metadata30("design:paramtypes", [
    String
  ]),
  _ts_metadata30("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], PromptSkillsController.prototype, "remove", null);
PromptSkillsController = _ts_decorate30([
  Controller30("prompt-skills")
], PromptSkillsController);

// src/controllers/media-crawler.controller.ts
import { Controller as Controller31, Get as Get28, Post as Post20, Body as Body21, Query as Query21 } from "@sker/core";
function _ts_decorate31(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate31, "_ts_decorate");
function _ts_metadata31(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata31, "_ts_metadata");
function _ts_param30(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
}
__name(_ts_param30, "_ts_param");
var MediaCrawlerController = class {
  static {
    __name(this, "MediaCrawlerController");
  }
  startCrawler(request) {
    throw new Error("method startCrawler not implements");
  }
  stopCrawler() {
    throw new Error("method stopCrawler not implements");
  }
  getCrawlerStatus() {
    throw new Error("method getCrawlerStatus not implements");
  }
  getCrawlerLogs(limit) {
    throw new Error("method getCrawlerLogs not implements");
  }
  getDataFiles(platform, fileType) {
    throw new Error("method getDataFiles not implements");
  }
  getDataFileContent(filePath, preview, limit) {
    throw new Error("method getDataFileContent not implements");
  }
  getDataStats() {
    throw new Error("method getDataStats not implements");
  }
  checkEnvironment() {
    throw new Error("method checkEnvironment not implements");
  }
  getPlatforms() {
    throw new Error("method getPlatforms not implements");
  }
  getConfigOptions() {
    throw new Error("method getConfigOptions not implements");
  }
  getLoginQRCode(platform) {
    throw new Error("method getLoginQRCode not implements");
  }
  getLoginStatus(platform) {
    throw new Error("method getLoginStatus not implements");
  }
  loginWithCookie(request) {
    throw new Error("method loginWithCookie not implements");
  }
};
_ts_decorate31([
  Post20("crawler/start"),
  _ts_param30(0, Body21()),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", [
    typeof CrawlerStartRequest === "undefined" ? Object : CrawlerStartRequest
  ]),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "startCrawler", null);
_ts_decorate31([
  Post20("crawler/stop"),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", []),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "stopCrawler", null);
_ts_decorate31([
  Get28("crawler/status"),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", []),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getCrawlerStatus", null);
_ts_decorate31([
  Get28("crawler/logs"),
  _ts_param30(0, Query21("limit")),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", [
    Number
  ]),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getCrawlerLogs", null);
_ts_decorate31([
  Get28("data/files"),
  _ts_param30(0, Query21("platform")),
  _ts_param30(1, Query21("file_type")),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", [
    String,
    String
  ]),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getDataFiles", null);
_ts_decorate31([
  Get28("data/files/:filePath"),
  _ts_param30(0, Query21("filePath")),
  _ts_param30(1, Query21("preview")),
  _ts_param30(2, Query21("limit")),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", [
    String,
    Boolean,
    Number
  ]),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getDataFileContent", null);
_ts_decorate31([
  Get28("data/stats"),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", []),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getDataStats", null);
_ts_decorate31([
  Get28("env/check"),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", []),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "checkEnvironment", null);
_ts_decorate31([
  Get28("config/platforms"),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", []),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getPlatforms", null);
_ts_decorate31([
  Get28("config/options"),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", []),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getConfigOptions", null);
_ts_decorate31([
  Get28("login/qrcode"),
  _ts_param30(0, Query21("platform")),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", [
    typeof MediaPlatform === "undefined" ? Object : MediaPlatform
  ]),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getLoginQRCode", null);
_ts_decorate31([
  Get28("login/status"),
  _ts_param30(0, Query21("platform")),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", [
    typeof MediaPlatform === "undefined" ? Object : MediaPlatform
  ]),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "getLoginStatus", null);
_ts_decorate31([
  Post20("login/cookie"),
  _ts_param30(0, Body21()),
  _ts_metadata31("design:type", Function),
  _ts_metadata31("design:paramtypes", [
    typeof CookieLoginRequest === "undefined" ? Object : CookieLoginRequest
  ]),
  _ts_metadata31("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], MediaCrawlerController.prototype, "loginWithCookie", null);
MediaCrawlerController = _ts_decorate31([
  Controller31("media-crawler")
], MediaCrawlerController);

// src/types.ts
var RunStatus = /* @__PURE__ */ (function(RunStatus2) {
  RunStatus2["PENDING"] = "pending";
  RunStatus2["RUNNING"] = "running";
  RunStatus2["SUCCESS"] = "success";
  RunStatus2["FAILED"] = "failed";
  RunStatus2["CANCELLED"] = "cancelled";
  RunStatus2["TIMEOUT"] = "timeout";
  return RunStatus2;
})({});
var ScheduleType = /* @__PURE__ */ (function(ScheduleType2) {
  ScheduleType2["ONCE"] = "once";
  ScheduleType2["CRON"] = "cron";
  ScheduleType2["INTERVAL"] = "interval";
  ScheduleType2["MANUAL"] = "manual";
  return ScheduleType2;
})({});
var ScheduleStatus = /* @__PURE__ */ (function(ScheduleStatus2) {
  ScheduleStatus2["ENABLED"] = "enabled";
  ScheduleStatus2["DISABLED"] = "disabled";
  ScheduleStatus2["EXPIRED"] = "expired";
  return ScheduleStatus2;
})({});

// src/tokens.ts
import { InjectionToken } from "@sker/core";
var BETTER_FETCH = new InjectionToken(`BETTER_FETCH`);
var BETTER_STORE = new InjectionToken(`BETTER_STORE`);
var BETTER_OPTIONS = new InjectionToken(`BETTER_OPTIONS`);
var BETTER_FETCH_CONFIG = new InjectionToken(`BETTER_FETCH_CONFIG`);

// src/client-plugin.ts
import { CONTROLLES, PATH_METADATA, METHOD_METADATA, ROUTE_ARGS_METADATA, SSE_METADATA, RequestMethod, ParamType, root } from "@sker/core";
import { Observable as Observable3 } from "rxjs";
import { clone } from "@sker/workflow";
function createSkerClientPlugin() {
  const controllers = root.get(CONTROLLES, []);
  return {
    id: "sker",
    // 插件初始化时执行李代桃僵
    $InferServerPlugin: {},
    getActions: /* @__PURE__ */ __name(($fetch, $store, options) => {
      registerControllerProxies($fetch, $store, options);
      return buildBetterAuthActions(controllers);
    }, "getActions"),
    pathMethods: generatePathMethods(controllers)
  };
}
__name(createSkerClientPlugin, "createSkerClientPlugin");
function registerControllerProxies($fetch, $store, options) {
  const controllers = root.get(CONTROLLES, []);
  const providers = [];
  providers.push({
    provide: BETTER_FETCH,
    useValue: $fetch
  });
  providers.push({
    provide: BETTER_STORE,
    useValue: $store
  });
  providers.push({
    provide: BETTER_OPTIONS,
    useValue: options
  });
  for (const controllerClass of controllers) {
    providers.push({
      provide: controllerClass,
      useFactory: /* @__PURE__ */ __name(() => createControllerProxy(controllerClass, $fetch), "useFactory")
    });
  }
  root.set(providers);
}
__name(registerControllerProxies, "registerControllerProxies");
function buildBetterAuthActions(controllers) {
  const actions = {};
  for (const controllerClass of controllers) {
    const controllerPrefix = Reflect.getMetadata(PATH_METADATA, controllerClass) || "";
    const controllerName = getControllerName(controllerPrefix);
    if (!actions[controllerName]) {
      actions[controllerName] = {};
    }
    const methodNames = Object.getOwnPropertyNames(controllerClass.prototype).filter((name) => name !== "constructor");
    for (const methodName of methodNames) {
      const originalMethod = controllerClass.prototype[methodName];
      const methodPath = Reflect.getMetadata(PATH_METADATA, originalMethod) || "/";
      const httpMethod = Reflect.getMetadata(METHOD_METADATA, originalMethod);
      const routeArgs = Reflect.getMetadata(ROUTE_ARGS_METADATA, originalMethod) || {};
      const isSse = Reflect.getMetadata(SSE_METADATA, originalMethod) === true;
      if (httpMethod === void 0) continue;
      actions[controllerName][methodName] = createMethodProxy(controllerPrefix, methodPath, httpMethod, routeArgs, isSse);
    }
  }
  return actions;
}
__name(buildBetterAuthActions, "buildBetterAuthActions");
function createControllerProxy(controllerClass, $fetch) {
  const controllerPrefix = Reflect.getMetadata(PATH_METADATA, controllerClass) || "";
  const methodNames = Object.getOwnPropertyNames(controllerClass.prototype).filter((name) => name !== "constructor");
  const proxy = {};
  for (const methodName of methodNames) {
    const originalMethod = controllerClass.prototype[methodName];
    const methodPath = Reflect.getMetadata(PATH_METADATA, originalMethod) || "/";
    const httpMethod = Reflect.getMetadata(METHOD_METADATA, originalMethod);
    const routeArgs = Reflect.getMetadata(ROUTE_ARGS_METADATA, originalMethod) || {};
    const isSse = Reflect.getMetadata(SSE_METADATA, originalMethod) === true;
    if (httpMethod === void 0) continue;
    proxy[methodName] = createMethodProxy(controllerPrefix, methodPath, httpMethod, routeArgs, isSse);
  }
  return proxy;
}
__name(createControllerProxy, "createControllerProxy");
function createMethodProxy(controllerPrefix, methodPath, httpMethod, routeArgs, isSse) {
  if (isSse) {
    return (...args) => {
      const fullPath = buildFullPath(controllerPrefix, methodPath);
      const { urlParams, queryParams, bodyData } = extractParameters(args, routeArgs);
      const finalUrl = replaceUrlParams(fullPath, urlParams);
      return createPostSSEObservable(finalUrl, queryParams, bodyData);
    };
  }
  return async (...args) => {
    const fullPath = buildFullPath(controllerPrefix, methodPath);
    const { urlParams, queryParams, bodyData } = extractParameters(args, routeArgs);
    const finalUrl = replaceUrlParams(fullPath, urlParams);
    const isFormData = bodyData instanceof FormData;
    const requestBody = isFormData ? bodyData : bodyData ? clone(bodyData) : void 0;
    const $fetch = root.get(BETTER_FETCH);
    const { data, error } = await $fetch(finalUrl, {
      method: getHttpMethodString(httpMethod),
      query: queryParams,
      body: requestBody,
      throw: false
    });
    if (error) {
      throw new Error(`API error: ${error.message || JSON.stringify(error)}`);
    }
    if (data && typeof data === "object" && "success" in data) {
      const apiResponse = data;
      if (apiResponse.success) {
        return apiResponse.data;
      }
      throw new Error(`API error: ${JSON.stringify(data)}`);
    }
    return data;
  };
}
__name(createMethodProxy, "createMethodProxy");
function generatePathMethods(controllers) {
  const pathMethods = {};
  for (const controllerClass of controllers) {
    const controllerPrefix = Reflect.getMetadata(PATH_METADATA, controllerClass) || "";
    const methodNames = Object.getOwnPropertyNames(controllerClass.prototype).filter((name) => name !== "constructor");
    for (const methodName of methodNames) {
      const originalMethod = controllerClass.prototype[methodName];
      const methodPath = Reflect.getMetadata(PATH_METADATA, originalMethod) || "/";
      const httpMethod = Reflect.getMetadata(METHOD_METADATA, originalMethod);
      const isSse = Reflect.getMetadata(SSE_METADATA, originalMethod) === true;
      if (httpMethod !== void 0 && !isSse) {
        const fullPath = buildFullPath(controllerPrefix, methodPath);
        pathMethods[fullPath] = httpMethod === RequestMethod.GET ? "GET" : "POST";
      }
    }
  }
  return pathMethods;
}
__name(generatePathMethods, "generatePathMethods");
function getControllerName(path) {
  const segments = path.split("/").filter(Boolean);
  return segments[segments.length - 1] || "default";
}
__name(getControllerName, "getControllerName");
function createPostSSEObservable(url, queryParams, bodyData) {
  return new Observable3((subscriber) => {
    const abortController = new AbortController();
    let reader = null;
    const options = root.get(BETTER_OPTIONS);
    const baseURL = options?.baseURL || "";
    let fullUrl = baseURL ? `${baseURL}${url}` : url;
    if (queryParams && Object.keys(queryParams).length > 0) {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(queryParams)) {
        if (value !== void 0 && value !== null) {
          params.append(key, String(value));
        }
      }
      const queryString = params.toString();
      fullUrl = queryString ? `${fullUrl}?${queryString}` : fullUrl;
    }
    fetch(fullUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/event-stream",
        "Cache-Control": "no-cache"
      },
      body: JSON.stringify(clone(bodyData)),
      signal: abortController.signal,
      credentials: "include"
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      if (!response.body) {
        throw new Error("Response body is not readable");
      }
      reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      function read() {
        reader.read().then(({ done, value }) => {
          if (done) {
            subscriber.complete();
            return;
          }
          buffer += decoder.decode(value, {
            stream: true
          });
          const lines = buffer.split("\n");
          buffer = lines.pop() || "";
          for (const line of lines) {
            const trimmedLine = line.trim();
            if (trimmedLine === "" || trimmedLine.startsWith(":")) continue;
            if (trimmedLine.startsWith("data: ")) {
              try {
                const data = JSON.parse(trimmedLine.slice(6));
                subscriber.next(data);
              } catch (error) {
                console.warn("[SSE] JSON \u89E3\u6790\u5931\u8D25:", trimmedLine.slice(0, 100), error);
              }
            }
          }
          read();
        }).catch((error) => {
          if (error.name === "AbortError") {
            subscriber.complete();
          } else {
            bodyData.state = "fail";
            subscriber.next({
              ...bodyData
            });
            subscriber.complete();
          }
        });
      }
      __name(read, "read");
      read();
    }).catch((error) => {
      if (error.name !== "AbortError") {
        subscriber.error(error);
      } else {
        subscriber.complete();
      }
    });
    return () => {
      abortController.abort();
      reader?.cancel().catch(() => {
      });
    };
  });
}
__name(createPostSSEObservable, "createPostSSEObservable");
function buildFullPath(controllerPrefix, methodPath) {
  if (!controllerPrefix) return methodPath;
  if (!methodPath || methodPath === "/") return controllerPrefix;
  const normalizedPrefix = controllerPrefix.startsWith("/") ? controllerPrefix : `/${controllerPrefix}`;
  const normalizedPath = methodPath.startsWith("/") ? methodPath : `/${methodPath}`;
  return `${normalizedPrefix}${normalizedPath}`;
}
__name(buildFullPath, "buildFullPath");
function extractParameters(args, routeArgs) {
  const urlParams = {};
  const queryParams = {};
  let bodyData = void 0;
  for (const [, metadata] of Object.entries(routeArgs)) {
    const { index, type, key: paramKey } = metadata;
    const value = args[index];
    if (value === void 0) continue;
    switch (type) {
      case ParamType.PARAM:
        if (paramKey) urlParams[paramKey] = value;
        break;
      case ParamType.QUERY:
        if (paramKey) queryParams[paramKey] = value;
        else Object.assign(queryParams, value);
        break;
      case ParamType.BODY:
        if (paramKey) {
          bodyData = bodyData || {};
          bodyData[paramKey] = value;
        } else {
          bodyData = value;
        }
        break;
    }
  }
  return {
    urlParams,
    queryParams,
    bodyData
  };
}
__name(extractParameters, "extractParameters");
function replaceUrlParams(url, params) {
  return url.replace(/:([^\/]+)/g, (match, paramName) => {
    return params[paramName] !== void 0 ? String(params[paramName]) : match;
  });
}
__name(replaceUrlParams, "replaceUrlParams");
function getHttpMethodString(method) {
  const map = {
    [RequestMethod.GET]: "GET",
    [RequestMethod.POST]: "POST",
    [RequestMethod.PUT]: "PUT",
    [RequestMethod.DELETE]: "DELETE",
    [RequestMethod.PATCH]: "PATCH"
  };
  return map[method] || "GET";
}
__name(getHttpMethodString, "getHttpMethodString");
export {
  BETTER_FETCH,
  BETTER_FETCH_CONFIG,
  BETTER_OPTIONS,
  BETTER_STORE,
  ChartsController,
  ChatController,
  ClaudeController,
  ConfigController,
  CrawlerController,
  DerivedNodeController,
  EventStatisticsController,
  EventsController,
  KeywordsController,
  LayoutController,
  LlmChatLogsController,
  LlmModelProvidersController,
  LlmModelsController,
  LlmProvidersController,
  LlmProxyController,
  LoginController,
  MediaCrawlerController,
  OverviewController,
  PersonaController,
  PostsController,
  PromptOptimizerController,
  PromptRolesController,
  PromptSkillsController,
  ProxyController,
  RunStatus,
  ScheduleStatus,
  ScheduleType,
  SentimentController,
  SystemController,
  UploadController,
  UserRelationController,
  UsersController,
  WorkflowController,
  WorkflowDSLController,
  createSkerClientPlugin
};
//# sourceMappingURL=index.mjs.map